import * as React from "react";
import * as Scrivito from "scrivito";
import { getPageLink } from "utils";
import { AnimateOnReveal } from "components";

Scrivito.provideComponent("ImageWidget", ({ widget }) => {
  let image = (
    <Scrivito.ImageTag
      content={widget}
      attribute="image"
      alt={alternativeText(widget)}
    />
  );

  const link = widget.get("link");
  if (link && !Scrivito.isInPlaceEditingActive()) {
    image = <Scrivito.LinkTag to={getPageLink(link)}>{image}</Scrivito.LinkTag>;
  }

  return (
    <AnimateOnReveal
      animation={widget.get("animation")}
      classNames={`text-${widget.get("alignment")}`}
    >
      {image}
    </AnimateOnReveal>
  );
});

function alternativeText(widget) {
  const widgetAlternativeText = widget.get("alternativeText");
  if (widgetAlternativeText) {
    return widgetAlternativeText;
  }

  const image = widget.get("image");
  if (image) {
    return image.get("alternativeText");
  }

  return "";
}
